import { ProgramModule_mkProgram, ProgramModule_run } from "./fable_modules/Fable.Elmish.4.0.0-beta-3/program.fs.js";
import { Program_withReactSynchronous } from "./fable_modules/Fable.Elmish.React.4.0.0-beta-2/react.fs.js";
import { view, update, init } from "./Main.fs.js";
import "./styles/styles.css";


ProgramModule_run(Program_withReactSynchronous("app", ProgramModule_mkProgram(init, update, view)));

//# sourceMappingURL=App.fs.js.map
